/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      color: '#19508C',
      position: 'bottom-left',
      text: 'Contact Us',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop'],
      font: {
        family: 'AUTO',
      },
    },
    {
      mode: 'modal',
      icon: 'phone',
      color: '#19508C',
      position: 'bottom-left',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['tablet', 'mobile'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:200px;" src="https://lirp.cdn-website.com/a632c0d9/dms3rep/multi/opt/tacti+track+-+white-244w.png">',
    header_color: '#000000',
    description_text: 'Affordable, reliable, and covert GPS Tracking solutions for Law Enforcement',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(888) 866-2715',
        link: 'tel:+18888662715',
        txt_color_hover: '#19508C',
        bg_color: '#19508C',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'CONTACT US',
        link: '/contact-us/',
        bg_color: '#19508C',
        txt_color_hover: '#19508C',
        class_list: ['contact-us'],
        icon: 'email',
      },
    ],
    footer_text:
      'Tacti Track GPS is here to provide the Law Enforcement industry with cutting-edge GPS resources backed by our superior customer service.',
    footer_color: '',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call (888) 866-2715 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .contact-us',
      action: 'Contact Us - ConvertBoost©',
      event: 'click',
    },
  ]);
});
